export default function Products({data}) {
    let result = {
        on: {
            id: 4243,
            name: 'Olej napędowy',
            volume: 0
        },
        pb95: {
            id: 4241,
            name: 'PB95',
            volume: 0
        },
        lpg: {
            id: 4244,
            name: 'LPG',
            volume: 0
        },
        onplus: {
            id: 4242,
            name: 'ON Premium',
            volume: 0
        },
        pb98: {
            id: 9521,
            name: 'PB98',
            volume: 0
        },
        adb: {
            id: 4245,
            name: 'AdBlue',
            volume: 0
        }
    };
    for(const i of data) {    
        result.on.volume += new Number(i.today.products[4243].volume);
        result.pb95.volume += new Number(i.today.products[4241].volume);
        result.lpg.volume += new Number(i.today.products[4244].volume);
        result.onplus.volume += new Number(i.today.products[4242].volume);
        result.pb98.volume += new Number(i.today.products[9521].volume);
        result.adb.volume += new Number(i.today.products[4245].volume);
    };

    const Record = ({key, fuel}) => (
        <div key={key} className="record">
            <h6>{fuel.name}</h6>
            <p>{(fuel.volume).toFixed(2)} l</p>
        </div>
    )

    return (
        <div className="all-sales-products">
            { data && result && Object.entries(result).map(([key, fuel]) => <Record key={key} fuel={fuel}/>)}
        </div>
    )
};